import { Box } from "@mui/material"
import React, { useEffect } from "react"
import { ReportGenerateSwitch, ReportLimitHoursField } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import ReportExtraCategoriesField from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections/ExportFilters/Category"
import ReportExtrasAcrissField from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections/ExportFilters/Acriss"
import { AppIconChipToggle, AppFormGrid, AppFormSection } from "@components"
import { reportFormData, useExtrasAcriss } from "Pages/ReportsAlerts/Reports/@signals"

export default function ReportFormDrawerExportFiltersSection() {

	return <AppFormSection icon="sliders" title="Filters for Excel export & Generation" data-tour-id="tour-export-filters">
		<AppFormGrid>
			<AcrissCategorySwitch/>
			<Box sx={{ gridColumn: 'span 4' }}>
				<ReportLimitHoursField/>
			</Box>
			<Box sx={{ gridColumn: 'span 4', display: 'flex', alignItems: 'center', minHeight: 44 }}>
				<ReportGenerateSwitch/>
			</Box>
		</AppFormGrid>
	</AppFormSection>
}


function AcrissCategorySwitch() {

	useEffect(() => {
		useExtrasAcriss.value = !!reportFormData.peek().filterAcriss
	}, [])

	return <>
		<Box sx={{ gridColumn: 'span 8' }}>
			{useExtrasAcriss.value ? <ReportExtrasAcrissField/> : <ReportExtraCategoriesField/>}
		</Box>
		<Box sx={{ gridColumn: 'span 4', display: 'flex', alignItems: 'center', minHeight: 44 }}>
			<AppIconChipToggle
				aria-label="Filter by"
				value={!!useExtrasAcriss.value}
				options={[
					{ value: false, label: 'Categories', icon: 'layer-group' },
					{ value: true, label: 'Acriss', icon: 'car' },
				]}
				onChange={value => useExtrasAcriss.value = value}
			/>
		</Box>
	</>
}
